export default bytes => {
    const binString = String.fromCodePoint(...bytes)
    return btoa(binString)
}
